export default "__VITE_ASSET__CwFkgXEJ__"